module.exports = __webpack_public_path__ + "static/img/bg6.e6253ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg6.png
// module id = hNsv
// module chunks = 1